import { NgModule } from '@angular/core';
import { ApiService } from './api.service';

@NgModule({
  providers: [
    ApiService
  ]
})
export class ApiModule {
}



// WEBPACK FOOTER //
// ./src/app/api/api.module.ts